import React, { Component } from "react";
import { withTranslation } from "react-i18next";
import { connect } from "react-redux";

import "./Tooltip.scss";

function mapState(state) {
  return { tooltip: state.nav.tooltip };
}

class Tooltip extends Component {
  constructor(props) {
    super();
    this.state = {
      tooltipDelayed: props.tooltip
    };
  }

  componentDidUpdate(prevProps) {
    const tooltip = this.props.tooltip;
    const prevTooltip = prevProps.tooltip;

    // Delay unsetting the tooltip so out transition can play
    if (prevTooltip !== null && tooltip === null) {
      clearInterval(this.timerID);
      this.timerID = setTimeout(() => {
        this.setState({ tooltipDelayed: tooltip });
      }, 500);
    } else if (prevTooltip !== tooltip) {
      clearInterval(this.timerID);
      this.setState({ tooltipDelayed: tooltip });
    }
  }

  render() {
    const { t, tooltip } = this.props;
    const { tooltipDelayed } = this.state;

    const transKey = tooltipDelayed?.transKey || false;
    const text = transKey ? t(`hotspots.${transKey}_title`) : "";
    const style = {
      left: tooltipDelayed?.x || 0,
      top: tooltipDelayed?.y || 0
    };

    return (
      <div className={`app-tooltip ${tooltip ? "show" : ""}`}>
        <div className="tooltip" style={style}>
          <div className="tooltip-inner">{text}</div>
        </div>
      </div>
    );
  }
}

export default withTranslation()(connect(mapState)(Tooltip));
